import { Alert, Button, Col, Descriptions, Divider, Row, Space } from 'antd';
import Countdown from 'antd/lib/statistic/Countdown';
import moment from 'moment';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Map, MapMarker } from 'react-kakao-maps-sdk';
import { Image } from 'antd';

import {
  BidChance,
  BidChanceStatus,
  bidChanceStatusKorean,
} from '../../modules/bid-chances';
import { phoneFormatter } from '../../util/utils';
import ProjectSharedFileListComponent from '../projects/ProjectSharedFileListComponent';
import { styledDescriptions } from '../styled/mixin';
import Title from 'antd/lib/typography/Title';
import PDFViewModal2 from '../expenses/PDFViewModal2';

const StyledDiv = styled.div`
  ${styledDescriptions}
  h3 {
    font-size: 16px;
  }
  .ant-alert-message {
    font-size: 16px;
  }
`;

interface BidChanceDetailComponentProps {
  bidChance: BidChance;
  coords: any;
  moveToCreateBidProposalPage: () => void;
  downloadFile: (fileData: any) => void;
  changeBidStatus: (status: string) => void;
}
function BidChanceDetailComponent({
  bidChance,
  coords,
  moveToCreateBidProposalPage,
  downloadFile,
  changeBidStatus,
}: BidChanceDetailComponentProps) {
  const [isBidFinished, setIsBidFinished] = useState(
    moment(bidChance.bidder.bidPackage?.bidDueDateTime).isBefore(new Date()),
  );
  const [bidTypeName, setBidTypeName] = useState<string>('');
  const [visible, setVisible] = useState(false);
  const [imageData, setImageData] = useState<any>();
  const [previewFileType, setPreviewFileType] = useState<string>('');

  const openImagePreview = (file: any) => {
    setImageData(file);
    setVisible(true);
    if (file.name.split('.').pop() === 'pdf') {
      setPreviewFileType('pdf');
    } else if (
      file.name.split('.').pop() === 'jpeg' ||
      file.name.split('.').pop() === 'jpg' ||
      file.name.split('.').pop() === 'png'
    ) {
      setPreviewFileType('image');
    } else {
      setPreviewFileType('');
    }
  };

  useEffect(() => {
    setBidTypeName(bidChance.bidder.bidPackage?.isBudgeting ? '견적' : '입찰');
  }, [bidChance]);

  const onFinish = () => {
    setIsBidFinished(true);
  };

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Col>
          <Title level={1}>
            {bidChance.bidder.bidPackage?.project?.name} (
            {bidChance.bidder.bidPackage?.name})
          </Title>
        </Col>
        <Space style={{ marginRight: '20px' }}>
          <Col style={{ marginRight: '16px' }}>
            <Row>
              <span
                style={{
                  marginBottom: '8px',
                  marginTop: '8px',
                  fontSize: '14px',
                  color: 'rgba(0,0,0,0.45)',
                }}
              >
                상태
              </span>
            </Row>
            <Row>
              <h2>{bidChanceStatusKorean[bidChance.status]}</h2>
            </Row>
          </Col>
          <Col>
            {/* {(bidChance.status === BidChanceStatus.ACCEPTED ||
            bidChance.status === BidChanceStatus.SUBMITTED) && (
            <Button onClick={moveToCreateBidProposalPage}>입찰가 제출</Button>
          )}
          {bidChance.status !== BidChanceStatus.ACCEPTED && (
            <Button onClick={openUpdateBidChanceStatusModal}>
              입찰공고 상태 변경
            </Button>
          )} */}
            <Countdown
              title="남은시간"
              // value={Date.now() + 10 * 1000}
              value={bidChance.bidder.bidPackage?.bidDueDateTime}
              format="D일 H시 m분 s초"
              onFinish={onFinish}
            />
            {/* <Row>
              <span
                style={{
                  marginBottom: '8px',
                  marginTop: '8px',
                  fontSize: '14px',
                  color: 'rgba(0,0,0,0.45)',
                }}
              >
                마감일시
              </span>
            </Row>
            <Row>
              <Space>
                <Col>
                  <h2>
                    {moment(bidChance.bidder.bidPackage?.bidDueDateTime).format(
                      'YYYY-MM-DD',
                    )}
                  </h2>
                </Col>
                <Col>
                  <h3>
                    {moment(bidChance.bidder.bidPackage?.bidDueDateTime).format(
                      'HH:mm',
                    )}
                  </h3>
                </Col>
              </Space>
            </Row> */}
          </Col>
        </Space>
      </Row>
      <Row>
        <Col span={24}>
          {bidChance.status === BidChanceStatus.INVITED && (
            <Alert
              message={`${bidTypeName} 에 참여 하시겠습니까?`}
              type="warning"
              action={
                <Space>
                  <Button
                    size="small"
                    type="ghost"
                    disabled={isBidFinished}
                    onClick={() => changeBidStatus(BidChanceStatus.ACCEPTED)}
                  >
                    수락
                  </Button>
                  <Button
                    size="small"
                    type="ghost"
                    disabled={isBidFinished}
                    onClick={() => changeBidStatus(BidChanceStatus.DECLINED)}
                  >
                    거절
                  </Button>
                </Space>
              }
            />
          )}
          {bidChance.status === BidChanceStatus.ACCEPTED && (
            <Alert
              message={`${bidTypeName} 참가 수락 하셨습니다. 페이지 하단에 있는 설계도서를 확인하세요.`}
              type="success"
              closable
            />
          )}
          {bidChance.status === BidChanceStatus.ACCEPTED && (
            <Alert
              message={`${bidTypeName}가를 제출하세요.`}
              type="info"
              action={
                <Space>
                  <Button
                    size="small"
                    type="ghost"
                    disabled={isBidFinished}
                    onClick={moveToCreateBidProposalPage}
                  >
                    {`${bidTypeName}가 제출`}
                  </Button>
                </Space>
              }
            />
          )}
          {bidChance.status === BidChanceStatus.SUBMITTED && (
            <Alert
              message={`${bidTypeName}가를 제출완료 하셨습니다. 다시 제출하려면 오른쪽 버튼을 클릭하세요.`}
              type="warning"
              action={
                <Space>
                  <Button
                    size="small"
                    type="ghost"
                    disabled={isBidFinished}
                    onClick={moveToCreateBidProposalPage}
                  >
                    {`다시 제출`}
                  </Button>
                </Space>
              }
            />
          )}
          {bidChance.status === BidChanceStatus.RECONFIRM && (
            <Alert
              message={`재요청 사유 확인 후 ${bidTypeName}가를 다시 제출 해 주세요.`}
              type="warning"
              action={
                <Space>
                  <Button
                    size="small"
                    type="ghost"
                    disabled={isBidFinished}
                    onClick={moveToCreateBidProposalPage}
                  >
                    {`다시 ${bidTypeName}가 제출`}
                  </Button>
                </Space>
              }
            />
          )}
          {isBidFinished && (
            <Alert
              message={`${bidTypeName}이 마감 되었습니다.`}
              type="success"
              closable
            />
          )}
        </Col>
      </Row>
      {bidChance.bidder.reconfirmReason !== null && (
        <div style={{ marginTop: '30px', marginBottom: '30px' }}>
          <Row>
            <Title level={5} type="danger">
              재요청 사유: {`${bidChance.bidder.reconfirmReason}`}
            </Title>
          </Row>
        </div>
      )}
      <Descriptions
        title="클라이언트 정보"
        bordered
        column={2}
        size="small"
        style={{ marginTop: '30px', marginBottom: '30px' }}
      >
        <Descriptions.Item label="회사명">
          {bidChance.bidder.bidPackage?.project?.enterprise?.name}
        </Descriptions.Item>
        <Descriptions.Item label="회사주소">
          {bidChance.bidder.bidPackage?.project?.enterprise?.address}
        </Descriptions.Item>
        <Descriptions.Item label="대표명">
          {bidChance.bidder.bidPackage?.project?.enterprise?.representative}
        </Descriptions.Item>
        <Descriptions.Item label="연락처">
          {bidChance.bidder.bidPackage?.project?.enterprise?.corporatePhone ===
          undefined
            ? ''
            : phoneFormatter(
                bidChance.bidder.bidPackage?.project?.enterprise
                  ?.corporatePhone,
                1,
              )}
        </Descriptions.Item>
        <Descriptions.Item label="담당자 정보">
          {bidChance.bidder.bidPackage?.bidPackageManagers?.map(
            (user: any, index: any) => (
              <div key={index}>
                <span>{user.name}</span>
                {user.workPosition && (
                  <Space>
                    <Divider type="vertical" />
                    <span>{user.workPosition}</span>
                  </Space>
                )}
                {user.workPhone && (
                  <Space>
                    <Divider type="vertical" />
                    <span>{phoneFormatter(user.workPhone, 1)}</span>
                  </Space>
                )}
                {/* <Space>
                  <Divider type="vertical" />
                  <span>{user.email}</span>
                </Space> */}
              </div>
            ),
          )}
        </Descriptions.Item>
      </Descriptions>

      <Descriptions
        title="공사 정보"
        bordered
        column={2}
        size="small"
        style={{ marginTop: '30px', marginBottom: '30px' }}
      >
        <Descriptions.Item label="공사명">
          {bidChance.bidder.bidPackage?.project?.name}
        </Descriptions.Item>
        <Descriptions.Item label="위치">
          {bidChance.bidder.bidPackage?.project?.location}
        </Descriptions.Item>
        {/* <Descriptions.Item label="발주처">
          {bidChance.bidder.bidPackage?.project?.owner}
        </Descriptions.Item> */}
        {/* <Descriptions.Item label="설계사무소">
          {bidChance.bidder.bidPackage?.project?.architect}
        </Descriptions.Item> */}
        <Descriptions.Item label="공사기간">
          {bidChance.bidder.bidPackage?.startDate} ~{' '}
          {bidChance.bidder.bidPackage?.endDate}
        </Descriptions.Item>
        {/* {bidChance.bidder.bidPackage?.isBriefing && (
          <Descriptions.Item label="현장설명회 일시">
            {moment(bidChance.bidder.bidPackage?.jobWalkDateTime).format(
              'YYYY-MM-DD HH:mm',
            )}
          </Descriptions.Item>
        )}
        {bidChance.bidder.bidPackage?.isBriefing && (
          <Descriptions.Item label="현장설명회 장소">
            {bidChance.bidder.bidPackage?.briefingSite}
          </Descriptions.Item>
        )} */}
        <Descriptions.Item label={`${bidTypeName}마감일`}>
          {moment(bidChance.bidder.bidPackage?.bidDueDateTime).format(
            'YYYY-MM-DD HH:mm',
          )}
        </Descriptions.Item>
        <Descriptions.Item label="설명" style={{ whiteSpace: 'pre-wrap' }}>
          {bidChance.bidder.bidPackage?.project?.description}
        </Descriptions.Item>
        <Descriptions.Item label="요청사항" style={{ whiteSpace: 'pre-wrap' }}>
          {bidChance.bidder.bidPackage?.instructions}
        </Descriptions.Item>
      </Descriptions>
      {coords && (
        <div style={{ marginTop: '30px', marginBottom: '30px' }}>
          <Row>
            <Col>
              <h3>현장 위치</h3>
            </Col>
          </Row>
          <Map center={coords} style={{ width: '100%', height: '480px' }}>
            <MapMarker position={coords}>
              {/* <div style={{ color: '#000' }}>현장 위치</div> */}
            </MapMarker>
          </Map>
        </div>
      )}
      {/* <BidProposalListComponent
        isSovIncluded={bidChance.bidder.bidPackage!.isSovIncluded}
        bidProposals={bidChance.bidProposals}
        moveToBidProposalDetailPage={moveToBidProposalDetailPage}
        downloadFile={downloadFile}
      /> */}

      {bidChance &&
        bidChance.bidder.bidPackage!.attachedFiles &&
        (bidChance.status === BidChanceStatus.ACCEPTED ||
          bidChance.status === BidChanceStatus.SUBMITTED ||
          bidChance.status === BidChanceStatus.RECONFIRM ||
          bidChance.status === BidChanceStatus.WON) && (
          <div style={{ marginTop: '30px' }}>
            <Row>
              <h3>설계도서</h3>
            </Row>
            <Row>
              <Col flex={1}>
                <ProjectSharedFileListComponent
                  file={bidChance.bidder.bidPackage!.attachedFiles}
                  donwloadFile={(fileData) => {
                    // if (isMobile) {
                    //   if (
                    //     fileData.name.split('.').pop() === 'jpeg' ||
                    //     fileData.name.split('.').pop() === 'jpg' ||
                    //     fileData.name.split('.').pop() === 'png'
                    //   ) {
                    //     alert(
                    //       '스마트폰에서는 미리보기만 지원합니다. PC에서 다운로드 해 주세요.',
                    //     );
                    //     openImagePreview(fileData);
                    //     return;
                    //   }
                    // }

                    downloadFile(fileData);
                  }}
                  openImagePreview={openImagePreview}
                />
              </Col>
            </Row>
          </div>
        )}
      {imageData && previewFileType === 'image' && (
        <Image
          width={200}
          style={{ display: 'none' }}
          preview={{
            visible,
            src: imageData?.url,
            onVisibleChange: (value) => {
              setVisible(value);
              setImageData(null);
              setPreviewFileType('');
            },
          }}
        />
      )}
      {imageData && previewFileType === 'pdf' && (
        <PDFViewModal2
          visible={!!imageData}
          url={imageData.url}
          onCancel={() => {
            setImageData(null);
            setPreviewFileType('');
          }}
          onDownload={() => downloadFile(imageData)}
        />
      )}
    </StyledDiv>
  );
}

export default BidChanceDetailComponent;
